


























import { Vue, Component, Prop } from 'vue-property-decorator';
import { FilledButton } from '@/components/molecules';
import eventBus from '@/utils/eventBus';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import AppBusinessInfo from './AppBusinessInfo.vue';

@Component({
  components: {
    FilledButton,
    Typography,
    CloseModalIcon,
    AppBusinessInfo
  }
})
export default class PreviewAppBusiness extends Vue {
  @Prop() data!: any;

  onClose() {
    eventBus.$emit('closeModal');
  }
}
